/* eslint-disable */
import axios from 'axios'
import { memoryAdapter } from 'axios-extensions'
import i18next from 'i18next'

import { reactive } from "vue";
import { io } from "socket.io-client";

export const state = reactive({
  connected: false,
  fooEvents: [],
  barEvents: []
});

window.appInstanceCache = {};
window.cache_date = null;
const CACHE_TIME_LIMIT = 60000 * 720; // 1 minute * n
// Ignore persisted responses generated before option filtering used request context.
const RESPONSE_CACHE_VERSION = 2
const MAX_REQUESTS_COUNT = 5
const INTERVAL_MS = 10
let PENDING_REQUESTS = 0

window.numberOfAjaxCallPending = 0;
let VUE_APP_API_BASE_URL = 'https://gateway.taptasty.com/';
if (process.env.VUE_APP_API_BASE_URL) {
  VUE_APP_API_BASE_URL = process.env.VUE_APP_API_BASE_URL
}
window.is_local = 0
if (process.env.VUE_APP_IS_LOCAL) {
  window.is_local = parseInt(process.env.VUE_APP_IS_LOCAL)
}
window.API_HOST = VUE_APP_API_BASE_URL
// console.log(VUE_APP_API_BASE_URL);
// console.log(process.env.NODE_ENV);

let appInstance = axios.create({
  baseURL: window.API_HOST,
  withCredentials: false,
  timeout: 1000 * 60 * 10,
  adapter: memoryAdapter
})
appInstance.interceptors.request.use(function (config) {
  return new Promise((resolve, reject) => {
    let interval = setInterval(() => {
      if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
        PENDING_REQUESTS++
        clearInterval(interval)
        resolve(config)
      } 
    }, INTERVAL_MS)
  })
})
/**
 * Axios Response Interceptor
 */
appInstance.interceptors.response.use(function (response) {
  PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
  return Promise.resolve(response)
}, function (error) {
  PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
  return Promise.reject(error)
})

const localAppInstance = axios.create({
  baseURL: 'http://localhost:6999/',
  withCredentials: false,
  timeout: 1000 * 60 * 10 
})
const localFiscalNetInstance = axios.create({
  // baseURL: 'http://192.168.100.44:65400/',
  baseURL: 'http://localhost:65400/',
  withCredentials: false,
  timeout: 1000 * 60 * 10 
})
import getBrowserFingerprint from 'get-browser-fingerprint';
export const utilsMixin = {
  data() {
    return {
      socket: null,
      databaseName: '',
      showSettings: false,
      intervalForDatabaseCache: null,
      refresh_products_date: null,
      login_date: null,
      qr_link: null,
      cardQrPaymentEnabled: false,
      withVivaWallet: false,
      withNoSwipe: false,
      withAllowLoyality: false,
      fiscalDeviceId: null,
      kiosk_is_using_top_category: null,
      kiosk_is_using_fiscal_receipt_for_cash: null,
      kiosk_is_using_non_fiscal_receipt_for_card: null,
      table_use_tips: null,
      tip_suggestion: null,
      reorder_popup_minutes: null,
      checkFiscalNet: null,
      use_smso: null,
      loyalty_in_use: null,
      kiosk_pass: null,
      scaner_position: null,
      use_pager: false,
      serverPosIp: null,
      stopReceiptPrint: null,
      stopSectionPrint: null,
      useMethods: false,
      add_packing_method_to_comment: false,
      justCardTxtToKiosk: null,
      isUsingCashMachine: false,
      // Setare per-kiosk (table_manager.disable_cash_payment) din backend: daca e
      // bifata, plata cash e dezactivata pe acest kiosk indiferent de ce metode
      // de plata vin din apelul /paymentprofile.
      disableCashPayment: false,
      colors: [],
      noInternet: false,
      timeoutRefrashIfError: null,
      packing_method: null,
      DBprinter: false,
      DBpos: false,
      DBfiscal: false,
      DBfiscalNet: false,
      DBfiscalNetWithPos: false,
      token: false,
      shopping_cart_id: false,
      json: {},
      version: 2,
      position: null,
      error: true,
      errorType: 1,
      fingerprint: false,
      companyLogo: '../logott.png',
      allow_open_order: false,
      receipt_printer_transaction_data: null,
    };
  },
  created () {
    // *** also in App.vue
    this.json = new URL(location.href).searchParams.get('table')
    this.json = JSON.parse(atob(atob(this.json).substring(3)))
    // ***
    if (this.json) {
      if ((Math.floor(Date.now() / 1000) - this.json.timestamp) < 300) {  // 300sec = 5 min
        this.error = false
        this.errorType = 0
      }
    }
    if (this.json.type == 'Kiosk' || window.is_local) {
      this.error = false
      this.errorType = 0
    }
    // this.openApp();
    this.colors = {
      addBtnColor: '#ffca40',
      addBtnColorInv: '#000',
      iconsColor1: '#942007',
      iconsColor2: '#fff',
      secundarColor: '#B33012',
      principalColor: '#4D966D',
      sideBarBg: '#fff',
      mainPageBg: '#F1F1F1'
    }
    // if (localStorage['tapTable_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id]) {
    //   window.appInstanceCache = JSON.parse(localStorage['tapTable_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id])
    // }

    let time = 30000 // 0.5 min
    if (this.json.type == 'Kiosk') {
      time = 120000 // 2 min
    }
    
    this.databaseName = 'table_' + this.json.location_token + '_comp_' + this.json.company_id
    
    let versionDB = 2 // onupgradeneeded event if change the version
    this.openDatabaseAndReadOrCreate(this.databaseName, versionDB, 'menuForKiosk', 0);
    clearInterval(this.intervalForDatabaseCache)
    this.intervalForDatabaseCache = setInterval(()=>{
      this.openDatabaseAndReadOrCreate(this.databaseName, versionDB, 'menuForKiosk', 1);
    }, time)


    if (localStorage['tapTable_cache_date_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id]) {
      window.cache_date = new Date(localStorage['tapTable_cache_date_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id])
    }
  },
  methods: {
    // ========== OPȚIUNI: cantitate totală selectată vs. min_no/max_no ==========
    // min_no / max_no limitează SUMA cantităților din opțiune (nu numărul de valori
    // distincte). O valoare bifată fără allow_quantity contează ca 1; una cu
    // allow_quantity contează cât e cantitatea ei.
    getOptionSelectedQuantity (option) {
      if (!option || !option.values) return 0
      let sum = 0
      option.values.forEach((val) => {
        if (!val.checked) return
        if (
          option.type === 'checkbox' &&
          val.company_option_value &&
          val.company_option_value.allow_quantity
        ) {
          sum += parseInt(val.quantity) || 1
        } else {
          sum += 1
        }
      })
      return sum
    },
    // Cantitatea maximă pe care o poate lua o valoare, ținând cont și de bugetul
    // rămas din max_no (suma cantităților din opțiune nu poate depăși max_no).
    getOptionValueMaxQuantity (option, val) {
      const cov = val && val.company_option_value
      let base = (cov && parseInt(cov.max_quantity) > 0) ? parseInt(cov.max_quantity) : 99
      if (option && option.max_no && option.type === 'checkbox') {
        const maxNo = parseInt(option.max_no)
        if (maxNo > 0) {
          const selectedQty = this.getOptionSelectedQuantity(option)
          const thisQty = val.checked ? (parseInt(val.quantity) || 1) : 0
          const remaining = maxNo - selectedQty // buget rămas peste selecția curentă
          const allowedForThis = thisQty + Math.max(0, remaining)
          base = Math.min(base, allowedForThis)
        }
      }
      return base
    },
    openApp () {
      let packageName = "rosecasApp"
      let params = new URLSearchParams({
        foo: 'bar',
        baz: 'boom',
        cow: 'milk',
        php: 'hypertext processor'
      })
      // params = 'table?'. params.toString();
      window.location = 'intent://'+params+'#Intent;package=com.inmobito.'+packageName+';scheme='+packageName+';end;'
    },
    doThelogin (callback) {
      this.apiRequest('login-table', 'POST', {
            'position': this.position,
            'company_id': this.json.company_id,
            'table_id': this.json.id,
          }, (resp) => {
        if (!resp || !resp.data) {
          // No response from server: request failed OR timed out (no internet /
          // server unreachable). Stop the infinite loader and show the
          // "no internet" screen with a reload button.
          this.noInternet = true
          this.loader = false
          this.showSplashScreenModal = false
          return
        }
        this.noInternet = false
        if (resp.data && resp.data.status == true) {
          this.error = false
          this.errorType = 0
          clearTimeout(this.timeoutRefrashIfError)
          this.refresh_products_date = resp.data.data.refresh_products_date
          this.setKioskLanguages(resp.data.data.languages)
          this.companyLogo = resp.data.data.logo
          this.token = resp.data.data.token
          this.shopping_cart_id = resp.data.data.shopping_cart_id
          this.DBfiscal = JSON.parse(resp.data.data.fiscal)
          this.DBfiscalNet = resp.data.data.use_fiscal_net
          this.DBfiscalNetWithPos = resp.data.data.use_fiscal_net_with_pos
          this.DBprinter = JSON.parse(resp.data.data.printer)
          this.DBpos = JSON.parse(resp.data.data.pos)
          this.packing_method = resp.data.data.packing_method
          this.allow_open_order = resp.data.data.allow_open_order
          this.isUsingCashMachine = resp.data.data.use_cash_machine
          this.disableCashPayment = !!resp.data.data.disable_cash_payment
          this.cardQrPaymentEnabled = resp.data.data.use_card_qr_payment
          this.withVivaWallet = !!resp.data.data.with_viva_wallet
          this.withNoSwipe = resp.data.data.allow_swipe_categories
          this.withAllowLoyality = resp.data.data.allow_to_use_loyality_points
          this.table_use_tips = resp.data.data.use_tips
          this.tip_suggestion = resp.data.data.tip_suggestion
          this.reorder_popup_minutes = resp.data.data.reorder_popup_minutes || null
          this.fiscalDeviceId = resp.data.data.fiscal_device_id || null
          this.receipt_printer_transaction_data = resp.data.data.receipt_printer_transaction_data || null
          this.checkFiscalNet = resp.data.data.check_fiscal_net || null

          if (resp.data.data.location_id) {
            this.locationTrueId = resp.data.data.location_id || null
          }

          if (this.isUsingCashMachine && !this.socket) {
            this.socket = io("http://localhost:6997/", { autoConnect: false });

            this.socket.on("connect", () => {
              state.connected = true;
            });

            this.socket.on("disconnect", () => {
              state.connected = false;
            });

            this.socket.on("connection", (...args) => {
              state.fooEvents.push(args);
            });
          }

          // this.colors = resp.data.data.colors
          if (resp.data.data.colors) {
            if (resp.data.data.colors.principalColor) {
              this.colors.principalColor = resp.data.data.colors.principalColor;
            }
            if (resp.data.data.colors.secundarColor) {
              this.colors.secundarColor = resp.data.data.colors.secundarColor;
            }
            if (resp.data.data.colors.addBtnColor) {
              this.colors.addBtnColor = resp.data.data.colors.addBtnColor;
            }
            if (resp.data.data.colors.addBtnColorInv) {
              this.colors.addBtnColorInv = resp.data.data.colors.addBtnColorInv;
            }
            if (resp.data.data.colors.iconsColor1) {
              this.colors.iconsColor1 = resp.data.data.colors.iconsColor1;
            }
            if (resp.data.data.colors.iconsColor2) {
              this.colors.iconsColor2 = resp.data.data.colors.iconsColor2;
            }
            if (resp.data.data.colors.sideBarBg) {
              this.colors.sideBarBg = resp.data.data.colors.sideBarBg;
            }
            if (resp.data.data.colors.mainPageBg) {
              this.colors.mainPageBg = resp.data.data.colors.mainPageBg;
            }
          }
          
          this.useMethods = resp.data.data.use_methods
          this.add_packing_method_to_comment = resp.data.data.add_packing_method_to_comment
          this.serverPosIp = resp.data.data.serverPosIp
          this.stopSectionPrint = resp.data.data.stopSectionPrint
          this.stopReceiptPrint = resp.data.data.stopReceiptPrint
          this.justCardTxtToKiosk = resp.data.data.just_card_txt_to_kiosk
          this.qr_link = resp.data.data.qr_link
          this.use_pager = !!resp.data.data.use_pager
          this.scaner_position = resp.data.data.scaner_position
          this.kiosk_is_using_top_category = resp.data.data.kiosk_is_using_top_category
          this.kiosk_is_using_fiscal_receipt_for_cash = resp.data.data.kiosk_is_using_fiscal_receipt_for_cash
          this.kiosk_is_using_non_fiscal_receipt_for_card = resp.data.data.kiosk_is_using_non_fiscal_receipt_for_card
          this.kiosk_is_using_fiscal_receipt_for_sections = resp.data.data.kiosk_is_using_fiscal_receipt_for_sections
          this.use_smso = resp.data.data.use_smso
          this.loyalty_in_use = resp.data.data.loyalty_in_use
          this.kiosk_pass = resp.data.data.kiosk_pass
          if (!this.kiosk_pass) {
            this.kiosk_pass = this.json.id
          }
          // La fiecare pornire de kiosk verificam pe API daca a ramas vreo comanda
          // nefiscalizata (card/pos, ultimele 24h). Daca da, kioskul porneste direct
          // pe ecranul negru (cere operator). Apel separat, fire-and-forget: daca pica,
          // kioskul tot porneste normal.
          if (this.json.type == 'Kiosk') {
            this.checkKioskPendingFiscal()
          }
          callback(resp.data.data.ask_to_empty_the_order)
        } else {
          if (resp.data.data && resp.data.data.use_fiscal_net && resp.data.data.use_fiscal_net_with_pos) {
            this.DBfiscalNet = resp.data.data.use_fiscal_net
            this.DBfiscalNetWithPos = resp.data.data.use_fiscal_net_with_pos
            if (this.DBfiscalNet) {
              this.showSettings = true
            }
          }
          if (resp.data.data && resp.data.data.kiosk_pass) {
            this.kiosk_pass = resp.data.data.kiosk_pass
            if (!this.kiosk_pass) {
              this.kiosk_pass = this.json.id
            }
          }
          this.error = true
          if (resp.data.errors && resp.data.errors.cid) {
            this.errorType = 2
          }
          if (resp.data.errors && resp.data.errors.tid) {
            this.errorType = 3
          }
          if (resp.data.errors && resp.data.errors.uid) {
            this.errorType = 4
          }
          if (resp.data.errors && resp.data.errors.email) {
            this.errorType = 5
          }
          if (resp.data.errors && resp.data.errors.ld) {
            this.errorType = 6
          }
          if (resp.data.errors && resp.data.errors.distance) {
            this.errorType = 7
          }
          if (resp.data.errors && resp.data.errors.close) {
            this.errorType = 8
          }
        }
      }, { timeout: 15000 })
    },
    getCurrentLocation (callback) {
      // Avoid stacking multiple retry timers (e.g. repeated reload taps offline).
      clearTimeout(this.timeoutRefrashIfError)
      if (navigator.geolocation && this.json.type != 'Kiosk') {
        navigator.geolocation.getCurrentPosition((position) => {
          this.position = {
            'accuracy': position.coords.accuracy,
            'altitude': position.coords.altitude,
            'altitudeAccuracy': position.coords.altitudeAccuracy,
            'heading': position.coords.heading,
            'latitude': position.coords.latitude,
            'longitude': position.coords.longitude,
            'speed': position.coords.speed
          }
          this.doThelogin(callback)
        }, (e) => {
          console.log(e)
          console.log('ERROR Location')
          this.position = null
          this.doThelogin(callback)
        });
      } else {
        this.position = null
        this.doThelogin(callback)
      }
      this.timeoutRefrashIfError = setTimeout(() => {
        this.getCurrentLocation(callback)
      }, 10 * 60000);
    },
    changeLanguage(lng = null) {
      if (lng) {
        i18next.changeLanguage(lng)
        return lng
      } else {
        if (i18next.language == 'en') {
          i18next.changeLanguage('ro')
          // return 'en'
        } else {
          i18next.changeLanguage('en')
          // return 'ro'
        }
        return i18next.language
      }
    },
    clickOnRef (ref) {
      const el = this.$refs[ref]
      if (el && el[0] && typeof el[0].click === 'function') {
        el[0].click()
      }
    },
    reloadKiosk () {
      // Do NOT use window.location.reload(): offline it re-fetches the document
      // from the network and the browser shows its own native "You're offline"
      // page (a dead end). The SPA is already loaded, so just retry the login
      // in-app. The black no-internet screen stays visible until the retry
      // succeeds (noInternet is only cleared on a successful response), so there
      // is no white loader flash and no navigation away from our page.
      this.restart()
    },
    localRequestFiscalNet (url, method, data, callback) {
      data = data || {};

      localFiscalNetInstance.interceptors.request.use(function (config) {
          window.numberOfAjaxCallPending++;
          return config;
      }, function (error) {
          return Promise.reject(error);
      });

      localFiscalNetInstance.interceptors.response.use(function (response) {
        window.numberOfAjaxCallPending--;

        return response
      }, function (error) {
        window.numberOfAjaxCallPending--;

        return Promise.reject(error)
      })

      const headers = {
        'Content-Type': 'text/plain',
      };

      switch (method) {
        case 'GET':
          localFiscalNetInstance.get(url, {params: data}).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
            this.requestFailLog('local_fiscalnet_fail', 'GET', url, err)
          })
          break
        case 'POST':
          localFiscalNetInstance.post(url, '[\n'+data+'\n]', { headers } ).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
            this.requestFailLog('local_fiscalnet_fail', 'POST', url, err)
            callback(0)
          })
          break
        case 'PUT':
          localFiscalNetInstance.put(url, data).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
            this.requestFailLog('local_fiscalnet_fail', 'PUT', url, err)
          })
          break
        case 'DELETE':
          localFiscalNetInstance.delete(url).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
            this.requestFailLog('local_fiscalnet_fail', 'DELETE', url, err)
          })
          break
      }
    },
    localRequest(url, method, data, callback, overrideBaseURL = null) {
      data = data || {};

      let instance = localAppInstance
      if (overrideBaseURL) {
        instance = axios.create({
            baseURL: overrideBaseURL + '?target=' + encodeURIComponent(url),
            withCredentials: false,
            timeout: 1000 * 60 * 10
          })
        url = ''
      }

      instance.interceptors.request.use(config => {
        window.numberOfAjaxCallPending++;
        return config;
      }, error => Promise.reject(error));

      instance.interceptors.response.use(response => {
        window.numberOfAjaxCallPending--;
        return response;
      }, error => {
        window.numberOfAjaxCallPending--;
        return Promise.reject(error);
      });

      const handleError = (error) => {
        // console.error('localRequest error:', error);
        // Log generic pe orice esec al requestului local (POS server).
        this.requestFailLog('local_request_fail', method, url, error)
        callback({
          error: true,
          message: error.message || 'Request failed',
          response: error.response || null
        });
      };

      switch (method) {
        case 'GET':
          instance.get(url, { params: data }).then(callback).catch(handleError);
          break;
        case 'POST':
          instance.post(url, data).then(callback).catch(handleError);
          break;
        case 'PUT':
          instance.put(url, data).then(callback).catch(handleError);
          break;
        case 'DELETE':
          instance.delete(url).then(callback).catch(handleError);
          break;
      }
    },
    getSessionFingerprint () {
      if (this.fingerprint !== false && this.fingerprint != null) return this.fingerprint
      const generated = getBrowserFingerprint()
      if (this.json.type !== 'Kiosk') return generated

      // Screen, language and browser updates must not orphan a kiosk draft.
      const key = 'tapTastyOrder-kiosk-fingerprint-' + this.json.company_id + '-' + this.json.id
      try {
        const stored = localStorage.getItem(key)
        if (stored !== null && /^\d+$/.test(stored) && Number(stored) <= 4294967295) {
          return Number(stored)
        }
        localStorage.setItem(key, String(generated))
      } catch (error) {
        // Continue loading the menu when browser storage is unavailable.
      }
      return generated
    },
    apiRequest (url, method, data, callback, options = {}) {
      const reqConfig = {}
      if (options && options.timeout) reqConfig.timeout = options.timeout
      this.fingerprint = this.getSessionFingerprint()
      data = data || {};
      data['device_id'] = window.uuid;
      data['version'] = this.version;
      data['fingerprint'] = this.fingerprint;
      data['device_info'] = window.device || {};

      // if (this.json.company_id == 91) {
      //   appInstance = axios.create({
      //     baseURL: 'https://ml01.taptasty.com:9999/',
      //     withCredentials: false,
      //     timeout: 1000 * 60 * 10
      //   })
      // }

      let token = localStorage['tapTastyOrder-' + this.json.id + '-' + this.fingerprint]

      const cacheKey = JSON.stringify({ version: RESPONSE_CACHE_VERSION, url, method, data });
      if (window.appInstanceCache[cacheKey] && (Date.now() - window.appInstanceCache[cacheKey].timestamp) < CACHE_TIME_LIMIT) {
        // If response is cached and not expired, return it
        window.appInstanceCache[cacheKey].response.requestFromCache = true;
        callback(JSON.parse(JSON.stringify(window.appInstanceCache[cacheKey].response)));
        return;
      }

      // Show the black "no internet" screen and stop the loader.
      const showNoInternet = () => {
        this.noInternet = true
        this.loader = false
        this.showSplashScreenModal = false
      }
      // A failed request that was caused by connectivity (no internet / server
      // unreachable / timeout) should show the no-internet screen. HTTP errors
      // with an actual server response (e.g. 4xx/5xx) are NOT treated as offline.
      const isNetworkError = (err) => {
        if (!navigator.onLine) return true
        if (!err) return false
        if (err.response) return false
        return err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || err.message === 'Network Error'
      }
      const handleNetworkFail = (err) => {
        console.log(err)
        // Log generic pe orice esec al requestului (retea sau HTTP 4xx/5xx).
        this.requestFailLog('api_request_fail', method, url, err)
        if (isNetworkError(err)) {
          showNoInternet()
        }
        callback(null)
      }
      // Un raspuns 200 poate fi de fapt o eroare aplicativa (status/errors).
      // Il logam (la fel ca esecurile de transport) si intoarcem true ca sa
      // stim ca NU trebuie cache-uit. Ruleaza doar pentru requesturi reale,
      // nu pentru hit-urile din cache (acelea ies mai devreme, mai sus).
      const handleSuccess = (res) => {
        if (!this.isErrorResponse(res)) {
          return false
        }
        // Locatie inchisa (`errors: { close: true }`) NU este o eroare reala,
        // e o stare normala de business => nu o logam (dar tot o tratam ca
        // raspuns de eroare, ca sa nu ajunga in cache).
        if (this.isClosedLocationResponse(res)) {
          return true
        }
        this.requestFailLog('api_request_app_error', method, url, {
          message: 'app-level error response (HTTP 200)',
          response: { status: (res && res.status) || null, data: (res && res.data) || null }
        })
        return true
      }

      // If the device is fully offline, don't even wait for the request to
      // fail/timeout: show the no-internet screen right away.
      if (!navigator.onLine) {
        this.requestFailLog('api_request_fail', method, url, { message: 'offline (navigator.onLine=false)' })
        showNoInternet()
        callback(null)
        return
      }



      appInstance.interceptors.request.use(function (config) {
          window.numberOfAjaxCallPending++;

          if (window.numberOfAjaxCallPending == 1) {
            setTimeout(function() {
              if (window.numberOfAjaxCallPending >= 1) {
                // self.$f7.preloader.show();
              }
            }, 1 * 1000);
          }

          return config;
      }, function (error) {
          return Promise.reject(error);
      });

      appInstance.interceptors.response.use( (response) => {

        // A successful response means the internet is back: hide the
        // no-internet screen if it was showing (auto-recover the kiosk).
        if (this.noInternet) {
          this.noInternet = false
        }

        if (
          response.data &&
          response.data.errors &&
          response.data.errors.error === "Token Signature could not be verified."
        ) {
            window.location.reload();
        }

        if (response.data && response.data.data && response.data.data.token) {
          localStorage['tapTastyOrder-' + this.json.id + '-' + this.fingerprint] = response.data.data.token
        }

        window.numberOfAjaxCallPending--;

        if (window.numberOfAjaxCallPending <= 0) {
          // self.$f7.preloader.hide();
        }

        return response
      }, function (error) {
        window.numberOfAjaxCallPending--;

        if (window.numberOfAjaxCallPending == 0) {
          // self.$f7.preloader.hide();
        }

        return Promise.reject(error)
      })

      //appInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

      if (token) {
        appInstance.defaults.headers.common['Authorization'] = 'Bearer ' + token
      }

      switch (method) {
        case 'GET':
          appInstance.get(url, {params: data, ...reqConfig}).then(res => {
            var isErr = handleSuccess(res)
            // NU cache-uim raspunsurile de eroare (general, pentru orice request).
            if (data.with_cache && !isErr) {
              window.appInstanceCache[cacheKey] = {
                response: JSON.parse(JSON.stringify(res)),
                timestamp: Date.now()
              }
              // localStorage['tapTable_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id] = JSON.stringify(window.appInstanceCache)
            }
            callback(res)
          }).catch(handleNetworkFail)
          break
        case 'POST':
          appInstance.post(url, data, reqConfig).then(res => {
            handleSuccess(res)
            callback(res)
          }).catch(handleNetworkFail)
          break
        case 'PUT':
          appInstance.put(url, data, reqConfig).then(res => {
            handleSuccess(res)
            callback(res)
          }).catch(handleNetworkFail)
          break
        case 'DELETE':
          appInstance.delete(url, reqConfig).then(res => {
            handleSuccess(res)
            callback(res)
          }).catch(handleNetworkFail)
          break
      }
    },
    // Log generic de kiosk. Se apeleaza DOAR pe esec (daca merge, ramane logul de succes existent).
    // Fire-and-forget: nu blocheaza fluxul si nu arunca daca esueaza logarea in sine.
    kioskLog (payload) {
      payload = payload || {}
      try {
        this.apiRequest('/noauth/kiosk-log', 'POST', {
          company_id: (this.json && this.json.company_id) ? this.json.company_id : null,
          location_id: (this.json && this.json.location_id) ? this.json.location_id : null,
          // ID-ul mic, numeric, al locatiei (din login-table). Separat de location_id
          // ca sa putem face query usor fara sa-l confundam cu token-ul.
          true_location_id: this.locationTrueId || null,
          // Masa de la care vine logul, ca sa vedem toate erorile de la masa X.
          table_id: (this.json && this.json.id) ? this.json.id : null,
          order_id: payload.order_id || null,
          stage: payload.stage || null,
          event: payload.event || null,
          http_status: (payload.http_status !== undefined && payload.http_status !== null) ? payload.http_status : null,
          message: payload.message || null,
          data_to: payload.data_to || null,
          data_from: payload.data_from || null
        }, function () {
          // silence
        })
      } catch (e) {
        // logarea nu trebuie sa strice fluxul
      }
    },
    // Log generic pentru ORICE request esuat (eroare de retea SAU HTTP 4xx/5xx).
    // Este apelat centralizat din cele 3 functii de transport (apiRequest,
    // localRequest, localRequestFiscalNet), ca sa fie logat absolut orice request
    // din proiect (inclusiv QR) fara sa atingem fiecare call-site in parte.
    requestFailLog (stage, method, url, err) {
      try {
        // NU logam esecul chiar al endpointului de logare (altfel intram in bucla infinita).
        if (url && String(url).indexOf('kiosk-log') !== -1) {
          return
        }
        var httpStatus = (err && err.response && err.response.status) ? err.response.status : null
        this.kioskLog({
          stage: stage || 'request_fail',
          event: (method ? (method + ' ') : '') + (url || ''),
          http_status: httpStatus,
          message: (err && err.message) ? err.message : (err ? String(err) : 'request failed'),
          data_from: (err && err.response && err.response.data) ? err.response.data : null
        })
      } catch (e) {
        // logarea nu trebuie sa strice fluxul
      }
    },
    // Detecteaza daca un raspuns HTTP 200 este de fapt o EROARE aplicativa,
    // dupa conventiile API-ului:
    //   - `errors` ne-gol (array cu elemente, sau obiect/string truthy), SAU
    //   - campul `status` este prezent si falsy (ex: endpointul /product => `!status`).
    // Folosit ca sa NU cache-uim raspunsurile de eroare si ca sa le logam.
    isErrorResponse (res) {
      if (!res || !res.data) {
        return false
      }
      var d = res.data
      if (d.errors) {
        if (Array.isArray(d.errors)) {
          if (d.errors.length > 0) {
            return true
          }
        } else {
          // errors ca obiect/string ne-gol (ex: { error: "..." })
          return true
        }
      }
      // Doar cand cheia `status` exista explicit si e falsy (nu afecteaza
      // endpointurile care nu intorc deloc `status`).
      if (Object.prototype.hasOwnProperty.call(d, 'status') && !d.status) {
        return true
      }
      return false
    },
    // `errors: { close: true }` (ex: login-table cand locatia e inchisa) nu e o
    // eroare tehnica, ci o stare normala => nu are ce cauta in kiosk_logs.
    // Intoarce true DOAR daca `close` e singura eroare primita; daca vine si
    // altceva pe langa (ex: { close: true, tid: ... }) logam normal.
    isClosedLocationResponse (res) {
      if (!res || !res.data || !res.data.errors) {
        return false
      }
      var errs = res.data.errors
      if (typeof errs !== 'object' || Array.isArray(errs)) {
        return false
      }
      var keys = Object.keys(errs)
      if (keys.length === 0) {
        return false
      }
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] !== 'close') {
          return false
        }
      }
      return !!errs.close
    },
    openDatabaseAndReadOrCreate(dbName, version, storeName, $insert1Read0) {
      let self = this
      // Open a connection to the database
      let request = indexedDB.open(dbName, version);

      // Handle database setup or upgrade
      request.onupgradeneeded = (event) => {
        let db = event.target.result;
        // Create an object store if it doesn't exist
        console.log(db.objectStoreNames);
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: 'key' });
        }
      };

      // Handle success opening database
      request.onsuccess = (event) => {
        let db = event.target.result;
        if ($insert1Read0) {
          self.insertDefaultData(db, storeName);
        } else {
          // Start a transaction to read data
          let transaction = db.transaction([storeName], 'readonly');
          let objectStore = transaction.objectStore(storeName);

          // Get all records from the object store
          let getAllRequest = objectStore.getAll();

          getAllRequest.onsuccess = (event) => {
            let records = event.target.result;
            let reconstructedObject = {};
            records.forEach(record => {
              reconstructedObject[record.key] = record.value;
            });
            window.appInstanceCache = reconstructedObject;
            console.log('getFromDb')
          };

          getAllRequest.onerror = (event) => {
            // console.error('Error reading records:', event.target.error);
          };

          transaction.oncomplete = () => {
            db.close();
          };
        }
      };

      request.onerror = (event) => {
        console.error('Database error:', event.target.error);
      };
    },
    insertDefaultData(db, storeName) {
      let transaction = db.transaction([storeName], 'readwrite');
      let objectStore = transaction.objectStore(storeName);

      let defaultData = Object.entries(window.appInstanceCache);

      defaultData.forEach(([key, value]) => {

        let item = {
          key: key,
          value: value
        };

        let putRequest = objectStore.put(item);

        putRequest.onsuccess = (event) => {
          // console.log('Default data inserted or updated:', item);
        };

        putRequest.onerror = (event) => {
          // console.error('Error inserting or updating default data:', event.target.error);
        };
      });

      transaction.oncomplete = () => {
        db.close();
        console.log('savedInDb')
      };
    },
    generateLargeData(size) {
      let data = '';
      for (let i = 0; i < size; i++) {
        data += 'a'; // or any other character
      }
      return data;
    },
    prefetchImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
          resolve(url);
        };
        img.onerror = reject;
      });
    },
    async fetchAndSetImage(url) {
      try {
        const loadedImage = await this.prefetchImage(url)
        // this.prefetchedImage = loadedImage;
        // this.imageLoaded = true;
      } catch (error) {
        console.error('Error prefetching image:', error)
      }
    },
    async prefetchImages(urls) {
      try {
        const loadedImages = await Promise.all(urls.map(url => this.prefetchImage(url)))
        // this.prefetchedImage = loadedImages[0];
        // this.imageLoaded = true;
      } catch (error) {
        console.error('Error prefetching images:', error)
      }
    },
    // Option value has an active campaign discount (same shape as product.discount).
    // Note: product-detail enrichment may overwrite `price` with the payable
    // (discounted) amount, so do not require discounted_price < price.
    optionHasDiscount (optionValue) {
      if (!optionValue || !optionValue.discount) {
        return false
      }
      const discounted = optionValue.discount.discounted_price
      if (discounted === null || discounted === undefined) {
        return false
      }
      const discountAmount = parseFloat(optionValue.discount.discount)
      return parseFloat(discounted) >= 0 && discountAmount > 0
    },
    getOptionSgrUnitPrice (optionValue) {
      return parseFloat(optionValue && optionValue.price_sgr) || 0
    },
    // Pre-discount list unit (excludes SGR). Reconstructs when API set price = payable.
    getOptionListUnitPriceWithoutSgr (optionValue) {
      const price = parseFloat(optionValue && optionValue.price) || 0
      if (!this.optionHasDiscount(optionValue)) {
        return price
      }
      const discounted = parseFloat(optionValue.discount.discounted_price) || 0
      const discountAmount = parseFloat(optionValue.discount.discount) || 0
      // API left list price in `price`
      if (price > discounted) {
        return price
      }
      // API overwrote `price` with payable discounted amount
      return discounted + discountAmount
    },
    getOptionUnitPrice (optionValue) {
      return this.getOptionListUnitPriceWithoutSgr(optionValue) + this.getOptionSgrUnitPrice(optionValue)
    },
    getOptionDiscountedUnitPrice (optionValue) {
      return parseFloat(optionValue.discount.discounted_price) + this.getOptionSgrUnitPrice(optionValue)
    },
    getOptionPayableUnitPrice (optionValue) {
      if (this.optionHasDiscount(optionValue)) {
        return this.getOptionDiscountedUnitPrice(optionValue)
      }
      return this.getOptionUnitPrice(optionValue)
    },
    getOptionDiscountPercent (optionValue) {
      const original = this.getOptionListUnitPriceWithoutSgr(optionValue)
      const discounted = parseFloat(optionValue.discount.discounted_price)
      if (!original) {
        return 0
      }
      return Math.ceil((original - discounted) / original * 100)
    },
    // Formatted "+ price currency" for an option value (list or discounted), includes SGR.
    getOptionPriceLabel (optionValue, currencySymbol, quantity = 1, useDiscounted = false) {
      const qty = parseFloat(quantity) || 1
      const unit = useDiscounted
        ? this.getOptionDiscountedUnitPrice(optionValue)
        : this.getOptionUnitPrice(optionValue)
      const total = parseFloat((unit * qty).toFixed(2))
      if (!(total > 0)) {
        return ''
      }
      return '+ ' + total + ' ' + currencySymbol
    }
  }
}
